








































import "./list-card.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import UserAvatar from "../common/user-avatar.vue";
import AddClassHover from "./../common/add-class-hover.js";
let _ = require("lodash");

export default Vue.extend({
  name: "list-card",
  components: { UserAvatar },
  directives: { AddClassHover },
  props: {
    card: Object,
  },
  data() {
    return {
      dueDateTooltips: {
        "due-date-complete": "This card is completed.",
        "due-date-expired": "This card is overdue.",
        "due-date-warning": "This card is due in less than twenty-four hours.",
        "due-date-normal": "This card is due in the future.",
      },
    };
  },
  computed: {
    ...mapState("project", ["currentProject"]),
    dueDateClass() {
      let card = (this as any).card;

      if (card.dueDateSetting && card.dueDateSetting.dueDate) {
        let dueDate = new Date(card.dueDateSetting.dueDate);
        let today = new Date();
        let tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);

        if (card.dueDateSetting.completed === true) {
          return "due-date-complete";
        } else if (dueDate < today) {
          return "due-date-expired";
        } else if (dueDate < tomorrow) {
          return "due-date-warning";
        }
      }

      return "due-date-normal";
    },
    checklistResult() {
      let card = (this as any).card;
      let totalItemCount = 0;
      let checkedItemCount = 0;

      if (card.checklists && card.checklists.length > 0) {
        card.checklists.forEach((checklist) => {
          totalItemCount += checklist.items.length;
          checklist.items.forEach((item) => {
            if (item.done === true) {
              checkedItemCount++;
            }
          });
        });
      }

      return { total: totalItemCount, checked: checkedItemCount };
    },
    checklistClass() {
      let context = this as any;

      if (context.checklistResult.total > 0 && context.checklistResult.total == context.checklistResult.checked) {
        return "checklist-complete";
      } else {
        return "checklist-normal";
      }
    },
    members() {
      let context = this as any;
      let members = context.currentProject ? context.currentProject.members : [];
      let selectedMemberIds = context.card && context.card.selectedMemberIds ? context.card.selectedMemberIds : [];

      return selectedMemberIds
        .map((id) => {
          let result = _.find(members, function (member) {
            return id === member.memberId;
          });

          return result;
        })
        .filter((member) => !!member);
    },
  },
  methods: {
    getDueDateString(dueDate) {
      return moment(dueDate).format("MMM D");
    },
  },
});
